const colors = {
  primary: "#000000"
};

export default {
  colors
};
